import { render, staticRenderFns } from "./componentSelectMultiple.vue?vue&type=template&id=496b6c24&scoped=true&"
import script from "./componentSelectMultiple.vue?vue&type=script&lang=ts&"
export * from "./componentSelectMultiple.vue?vue&type=script&lang=ts&"
import style0 from "./componentSelectMultiple.vue?vue&type=style&index=0&id=496b6c24&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b6c24",
  null
  
)

export default component.exports